import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { branchShape, singleClickHoldsSettingsShape } from '@bibliocommons/bc-prop-types';
import SingleClickHoldsStatusButton from '../SingleClickHoldsStatusButton';

import Panel from '../../../shared/Panel';
import HelpLinkContainer from '../../../../containers/HelpLinkContainer';
import SingleClickHoldsForm from '../SingleClickHoldsForm';

import './SingleClickHoldsPanel.scss';

export default class SingleClickHoldsPanel extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false
    };
    this.bindAll('handleStatusButtonClick', 'handleCancel', 'handleSubmit');
  }

  renderButton() {
    return (
      <div className="button-wrapper">
        <SingleClickHoldsStatusButton
          singleClickHoldsEnabled={this.props.singleClickHoldsSettings.get('enabled', false)}
          handleClick={this.handleStatusButtonClick} />
        <HelpLinkContainer page="010singleclick" />
      </div>
    );
  }

  getCurrentBranchName() {
    const currentBranchCode = this.props.singleClickHoldsSettings.get('branchId');
    const branch = this.props.branches.find(b => b.get('code') === currentBranchCode);
    return branch ? branch.get('name') : '';
  }

  renderForm() {
    return (
      <SingleClickHoldsForm
        handleCancel={this.handleCancel}
        handleSubmit={this.handleSubmit}
        branchCode={this.props.singleClickHoldsSettings.get('branchId')}
        branches={this.props.branches} />
    );
  }

  renderCurrentLocation() {
    const branch = <div className="branch-name">{this.getCurrentBranchName()}</div>;
    return (
      <div className="current-branch">
        <FormattedMessage
          id="single_click_holds_current_location"
          values={{ branch }} />
      </div>
    );
  }

  renderButtonAndLocation() {
    return (
      <div>
        {this.renderButton()}
        {this.props.singleClickHoldsSettings.get('enabled', false) && this.renderCurrentLocation()}
      </div>
    );
  }

  render() {
    return (
      <Panel className="cp-single-click-holds-panel">
        {this.state.showForm ? this.renderForm() : this.renderButtonAndLocation()}
      </Panel>
    );
  }

  handleStatusButtonClick() {
    this.setState({ showForm: true });
  }

  handleCancel() {
    this.setState({ showForm: false });
  }

  handleSubmit({ branchCode }) {
    this.props.accountActions.updateSingleClickHoldsSettings(
      this.props.accountId,
      true,
      branchCode
    );

    this.setState({ showForm: false });
  }
}

SingleClickHoldsPanel.propTypes = {
  accountId: PropTypes.number,
  singleClickHoldsEnabled: PropTypes.bool,
  branches: ImmutablePropTypes.listOf(branchShape),
  singleClickHoldsSettings: singleClickHoldsSettingsShape,
  accountActions: PropTypes.objectOf(PropTypes.func)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SingleClickHoldsPanel/SingleClickHoldsPanel.jsx